import format from "date-fns/format";

export default (date) => {
  let time = format(new Date(date), "h:mm");
  return time;
};
